import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';
import { ContractLayoutComponent } from '../../../layouts/contract-layout/contract-layout.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { UsageAgreementComponent } from './pages/usage-agreement/usage-agreement.component';
import { PartnerEarningsComponent } from './pages/partner-earnings/partner-earnings.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('../../../layouts/contract-layout/contract-layout.component').then(mod => mod.ContractLayoutComponent),
    children: [

      {
        path: 'chrome-extensions',
        data: {
          pageInfoSEOKey: 'chromeExtensions',
        },
        loadComponent: () => import('./pages/chrome-extensions/chrome-extensionscomponent').then(mod => mod.ChromeExtensionsComponent),
      },
      {
        path: 'about-us',
        data: {
          pageInfoSEOKey: 'aboutUs',
        },
        loadComponent: () => import('./pages/about-us/about-us.component').then(mod => mod.AboutUsComponent),
      },
      {
        path: 'privacy-policy',
        data: {
          pageInfoSEOKey: 'privacyPolicy',
        },
        loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(mod => mod.PrivacyPolicyComponent),
      },
      {
        path: 'usage-agreement',
        data: {
          pageInfoSEOKey: 'usageAgreement',
        },
        loadComponent: () => import('./pages/usage-agreement/usage-agreement.component').then(mod => mod.UsageAgreementComponent),
      },
      {
        path: 'partner-earnings',
        data: {
          pageInfoSEOKey: 'partnerEarnings',
        },
        loadComponent: () => import('./pages/partner-earnings/partner-earnings.component').then(mod => mod.PartnerEarningsComponent),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractRoutingModule { }
